import { jsx } from 'react/jsx-runtime';
import { styled, alpha } from '@mui/material';

function Avatar({ isLoading, sx, "data-testid": dataTestId, children }) {
    return (jsx(Wrapper, { "$isLoading": isLoading, "data-testid": dataTestId, sx: sx, tabIndex: 0, children: children }));
}
const Wrapper = styled("figure")(({ theme, $isLoading }) => (Object.assign(Object.assign({ alignItems: "center", backgroundColor: $isLoading ? theme.palette.ui50 : theme.palette.primary.main, borderRadius: "50%", cursor: "pointer", display: "flex", height: 28, justifyContent: "center", margin: 0, overflow: "hidden", width: 28, "&:hover": {
        outline: `4px solid ${alpha(theme.palette.primary.main, 0.1)}`,
    }, "&:active": {
        outline: `4px solid ${alpha(theme.palette.primary.main, 0.2)}`,
    } }, ($isLoading && {
    cursor: "default",
    "&:hover, &:active": {
        outline: "none",
    },
})), { "> *": {
        visibility: $isLoading ? "hidden" : "visible",
    } })));

export { Avatar };
//# sourceMappingURL=Wrapper.js.map
